<p-toast></p-toast>

<p-toast position="top-center" key="c" (onClose)="onReject()">
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column" style="flex: 1">
      <div class="text-center">
        <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
        <h4>{{ message.summary }}</h4>
        <p>{{ message.detail }}</p>
      </div>
      <div class="grid p-fluid">
        <div class="col-6">
          <button
            type="button"
            pButton
            (click)="onConfirm()"
            label="Yes"
            class="p-button-success"
          ></button>
        </div>
        <div class="col-6">
          <button
            type="button"
            pButton
            (click)="onReject()"
            label="No"
            class="p-button-secondary"
          ></button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>

<div class="layout-topbar">
  <a
    class="layout-topbar-logo ml-2.5"
    routerLink="/pages/punto-de-venta/caja-registradora"
  >
    <img src="assets/layout/images/logo.svg" alt="logo" />
    <!-- <span>AmigaFarma</span> -->
  </a>

  <!-- <a
    class="p-link layout-menu-button layout-topbar-button"
    href="#"
    (click)="appMain.toggleMenu($event)"
  >
    <i class="pi pi-bars"></i>
  </a> -->

  <a
    class="p-link layout-topbar-menu-button layout-topbar-button"
    href="#"
    (click)="appMain.toggleTopMenu($event)"
  >
    <i class="pi pi-ellipsis-v"></i>
  </a>

  <div
    class="ml-2 hidden lg:block absolute lg:static lg:w-auto w-full surface-overlay left-0 top-100 z-1"
  >
    <p-menubar autoDisplay="true" [model]="items"> </p-menubar>
  </div>

  <div
    class="layout-topbar-menu"
    [ngClass]="{ 'layout-topbar-menu-mobile-active': appMain.topMenuActive }"
  >
    <!-- <a href="#" class="p-link layout-topbar-button">
      <i class="pi pi-calendar"></i>
      <span>Calendar</span>
    </a> -->
    <!-- <a href="#" class="p-link layout-topbar-button">
      <i class="pi pi-cog"></i>
      <span>Settings</span>
    </a> -->
    <div class="flex align-items-center justify-content-center font-medium">
      {{ fullName | titlecase }}
    </div>

    <button
      class="p-link layout-topbar-button"
      pTooltip="Cerrar Sesión"
      tooltipPosition="left"
    >
      <i class="pi pi-sign-out" (click)="showConfirm()"></i>
    </button>
  </div>
</div>
